export const PAGINATION_LOCALE_ZHCHS = {
    message: 'å± <b>{1}</b> æ¡ ',
    totalinfo: {
        firstText: 'å±',
        lastText: 'æ¡'
    },
    pagelist: {
        firstText: 'æ¯é¡µ',
        lastText: 'æ¡'
    },
    previous: 'ä¸ä¸é¡µ',
    next: 'ä¸ä¸é¡µ',
    goto: {
        prefix: 'è·³è³',
        suffix: 'é¡µ'
    }
};
